import { advantages, stats } from '@/mocks/home';

export default function AdvantagesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary-600 text-sm font-semibold tracking-wide">为什么选择我们</span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2">
              平台优势
            </h2>
            <p className="text-foreground-500 text-sm mt-2">开元体育为每一位用户提供专业、安全、流畅的体育娱乐体验</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8 mb-14">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600 mb-1">{stat.value}</p>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {advantages.map((adv) => (
              <div
                key={adv.title}
                className="bg-background-50 border border-background-200 rounded-lg p-6 hover:border-primary-300 transition-all duration-200"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className={`${adv.icon} text-lg`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-2">{adv.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{adv.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}